import { render } from "./TestPage.vue?vue&type=template&id=582f871a&scoped=true"
const script = {}

import "./TestPage.vue?vue&type=style&index=0&id=582f871a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582f871a"]])

export default __exports__